<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :width="sizeSlideOver"
        :submit="handleUpdateGroupPermission"
        :title="groupEdit?.name"
        @close="handleClose"
        @undo="undo">
        <template #body>
            <div class="hts-company-group-ignore-add-group">
                <div
                    class="hts-company-group-ignore-add-group__container-body"
                    :class="sizeItemInput">
                    <hts-card>
                        <template #title>
                            <h3 class="title">
                                <span class="label">
                                    {{ $t('labels.updatePermissions') }}
                                </span>
                            </h3>
                        </template>
                        <div class="flex align-middle justify-end mb-2">
                            <span class="text-lg font-bold">
                                {{ $t('labels.checkAll') }}
                            </span>
                            <input
                                class="ml-2"
                                type="checkbox"
                                :checked="isCheckAll || dataFormCompanyGroup.isAdmin"
                                :disabled="dataFormCompanyGroup.isAdmin"
                                @change="(e) => actionCheckAll()" >
                        </div>
                        <permission-checkbox
                            :permissions="permissionRef"
                            :action-checkbox="actionCheckbox"
                            :action-sub-checkbox="actionSubCheckbox"
                            :data-group-permissions="dataGroupPermissions"
                            :is-admin="dataFormCompanyGroup.isAdmin" />
                    </hts-card>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>
<script setup lang="ts">
import PermissionCheckbox from '../-components/ignore/permission-checkbox.vue'
import dataForm from './imports/model'
import permissions from '~/data/permissions/trucker/index'

const store = $store()

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  groupEdit: {
    type: Object,
    default: () => {}
  }
})

const dataFormCompanyGroup = reactive({ ...dataForm.initValue })
const dataGroupPermissions = ref<Array<String>>([])
const permissionRef = reactive([...permissions])
const isCheckAll = ref(false)
const emits = defineEmits(['close', 'refreshTables', 'undo'])
const handleClose = () => {
  emits('close')
}
watch(props.groupEdit, () => {
  _init()
})

const _init = () => {
  Object.assign(dataFormCompanyGroup, props.groupEdit)
  dataGroupPermissions.value = dataFormCompanyGroup.permissions
}

const undo = () => {
  _init()
}

const actionCheckbox = (e: any, permission: any, action: boolean) => {
  e.stopPropagation()
  if (action) {
    if (!dataGroupPermissions.value.includes(permission.permissionKey)) {
      dataGroupPermissions.value.push(permission.permissionKey)
    }
  } else {
    dataGroupPermissions.value = dataGroupPermissions.value.filter(function (ele) {
      return ele !== permission.permissionKey
    })
  }

  if (!permission.children) {
    return
  }

  permission.children.map((item: any) => {
    return actionCheckbox(e, item, action)
  })
  parentCheck()
}

const actionSubCheckbox = (e: any, permissionKey: string) => {
  if (!dataGroupPermissions.value.includes(permissionKey)) {
    dataGroupPermissions.value.push(permissionKey)
  } else {
    dataGroupPermissions.value = dataGroupPermissions.value.filter(function (ele) {
      return ele !== permissionKey
    })
  }
  parentCheck()
}

const parentCheck = (permission?: Array<any> | undefined) => {
  const data = permission && Array.isArray(permission) ? permission : permissionRef
  const result = data.map((item: any) => {
    if (!item.children) {
      return false
    }

    const check = item.children.map((children: { [key: string]: any }) => {
      if (children.children) {
        return parentCheck([children])
      }
      return dataGroupPermissions.value.includes(children.permissionKey)
    })

    if (check.includes(true)) {
      if (!dataGroupPermissions.value.includes(item.permissionKey)) {
        dataGroupPermissions.value.push(item.permissionKey)
      }
      return true
    } else {
      dataGroupPermissions.value = dataGroupPermissions.value.filter(function (ele) {
        return ele !== item.permissionKey
      })
      return false
    }
  })

  return result.includes(true)
}

const actionCheckAll = (permission?: Array<any> | undefined) => {
  const data = permission && Array.isArray(permission) ? permission : permissionRef
  if (!permission) {
    isCheckAll.value = !isCheckAll.value
  }
  if (!isCheckAll.value) {
    dataGroupPermissions.value = []
    return
  }
  data.map((item: any) => {
    if (!dataGroupPermissions.value.includes(item.permissionKey)) {
      dataGroupPermissions.value.push(item.permissionKey)
    }

    if (!item.children) {
      return item
    }

    item.children.map((subItem: any) => {
      if (!subItem.children) {
        if (subItem.isDisabled !== undefined) {
          subItem.isDisabled = !isCheckAll.value
        }
        dataGroupPermissions.value.push(subItem.permissionKey)
        return ''
      } else {
        return actionCheckAll([subItem])
      }
    })
    return ''
  })
}

const getGroup = computed(() => {
  return store.system.getGroup
})

const setGroupStore = async (data: { [key: string]: any }) => {
  const group = getGroup.value
  if (group._id !== data._id) {
    return
  }
  await store.system.setGroup(data)
}

const handleUpdateGroupPermission = () => {
  const dataRequest = {
    id: props.groupEdit._id,
    permissions: dataGroupPermissions.value
  }
  const api = $url.companyGroup.updatePermissions
  $api(api, { body: dataRequest })
    .then(async (data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        process.client && $toast().success($t('labels.updateGroupSuccess'))
        await setGroupStore(responseData.data)
        emits('refreshTables')
        emits('close')
        undo()
      }
    })
    .catch((error: any) => error)
}
</script>
